module.exports = __webpack_public_path__ + "img/odonto_emergenza_implantologia_singolo.d503a8c3.jpg";